import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FilesService } from '@check-list/app/shared/services/files/files.service';
import { UploadDirectory } from '@check-list/core/models/upload-directory.model';
import { UploadEntity } from '@check-list/core/models/upload-entity.model';
import { UploadFile } from '@check-list/core/models/upload-file.model';
import { UploadFolders } from '@check-list/core/models/upload-folders.model';
import { TranslocoService } from '@ngneat/transloco';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'authority-labs-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {
  uploadQueueChanged = new EventEmitter<UploadFile>();
  translationPath = 'fileStorage.';
  uploadList: UploadFile[] = [];
  fileDirectory: UploadFolders;
  title: string;

  zones: UploadDirectory[] = [];

  constructor(
    public filesService: FilesService,
    private msg: NzMessageService,
    private translocoService: TranslocoService,
    public dialogRef: MatDialogRef<UploadComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { folders: UploadFolders; entityData: UploadEntity }
  ) {
    this.title =
      this.translocoService.translate(`${this.translationPath}upload`) +
      ' - ' +
      (data.entityData.name || String(data.entityData.id));
    this.fileDirectory = data.folders;
    this.uploadQueueChanged.subscribe((file) => this.onAddingFile(file));
  }

  ngOnInit(): void {
    this.setZoneParams();
  }

  private setZoneParams() {
    const zoneKeys = Object.keys(this.fileDirectory).filter(
      (key) => !!this.fileDirectory[key]
    );
    const width = `${100 / zoneKeys.length}%`;
    zoneKeys.forEach((key) =>
      this.zones.push(
        new UploadDirectory({
          width,
          namePath: key,
          id: this.fileDirectory[key],
          filesListChanged: this.uploadQueueChanged,
          uploadEntity: this.data.entityData
        })
      )
    );
  }

  removeItem(file: UploadFile) {
    const ind = this.uploadList.indexOf(file);
    if (ind > -1) {
      this.uploadList.splice(ind, 1);
    }
  }

  upload() {
    this.filesService.upload(this.uploadList);
    this.dialogRef.close();
  }

  private onAddingFile(file: UploadFile) {
    if (!file.filteredBy) {
      this.uploadList = [file, ...this.uploadList];
    } else {
      this.translocoService
        .selectTranslate(`${this.translationPath}filters.${file.filteredBy}`, {
          name: file.file.name
        })
        .subscribe((res) => this.msg.error(res, { nzDuration: 5000 }));
    }
  }
}
